export class MentalSoundConfig {
    // background loops
    public static readonly MAIN_GAME_AMBIANCE: string = "mainLoop";
    public static readonly STANDARD_FS_AMBIANCE: string = "freespinAutopsy";
    public static readonly COOL_FS_AMBIANCE: string = "freespinLobotomy";
    public static readonly SUPER_FS_AMBIANCE: string = "freespinMental";
    public static WIN_CAP_LOOP: string = "winCapLoop";

    // light flicker
    public static readonly LIGHTS_FLICKER: string[] = ["lightsFlicker01", "lightsFlicker02", "lightsFlicker03", "lightsFlicker04"];

    // reel spin
    public static REEL_SPIN: string = "reelSpin";

    // fire frame
    public static REEL_FIRE: string[] = ["reel1Fire", "reel2Fire", "reel3Fire", "reel4Fire", "reel5Fire"];

    // reel bounce
    public static REELS_DEFAULT_BOUNCE: string[] = ["reel1Land", "reel2Land", "reel3Land", "reel4Land", "reel5Land"];

    // xSplit
    public static X_SPLIT: string = "xSplit";
    public static REEL_SPLIT: string[] = ["reel1Split", "reel2Split", "reel3Split", "reel4Split", "reel5Split"];

    // init win and count up
    public static INIT_WIN: string = "initWin";
    public static COUNT_UP: string = "countup";
    public static COUNT_UP_ENDS_TINY: string = "countupEndsTiny";
    public static COUNT_UP_ENDS_SMALL: string = "countupEndsSmall";
    public static COUNT_UP_ENDS_MEDIUM: string = "countupEndsMedium";
    public static COUNT_UP_ENDS_LARGE: string = "countupEndsLarge";

    // big win
    public static INIT_WIN_BIG_WIN: string = "initWinBig";
    public static BIG_WIN: string[] = ["bigWin1", "bigWin2", "bigWin3", "bigWin4", "bigWin5"];
    public static BIG_WIN_END: string = "bigWinEnd";

    // S2 explosion
    public static EXPLOSION: string[] = ["explosion01", "explosion02", "explosion03"];
    public static EXPLOSION_BLOOD: string = "explosionBlood";
    public static EXPLOSION_ELECTRICITY: string = "explosionElectricity";

    // enhancer
    public static ENHANCER_HATCHES_FALL: string = "enhancerHatchesFall";

    // xWays
    public static X_WAYS: string = "xWays";

    // xNudge
    public static NUDGE: string = "nudge";
    public static WILD_SKULL: string = "wildSkull";

    // wild landing
    public static WILD_LANDING: string = "wildSkullNoWin";

    // fsIntro
    public static FS_INTRO: string = "freespinIntro";
    public static FS_BTN_CLICK: string = "buttonFSContinue";
    public static FS_END: string = "freespinEnd";
    public static FS_END_LOOP: string = "freespinEndLoop";
    public static FS_UPGRADE_COUNTER: string = "freespinUpgradeCounter";
    public static FS_AUTOPSY_DOOR_OPEN: string = "fsElevatorAutopsy";
    public static FS_LOBOTOMY_DOOR_OPEN: string = "fsElevatorLobotomy";
    public static FS_MENTAL_DOOR_OPEN: string = "fsElevatorMental";
    public static FS_DOOR_CLOSE: string = "fsElevatorDoorClose";

    // dead
    public static DEAD_TURN_ACTIVE: string = "deadSymbolGravestone";
    public static DEAD_COLLECT: string = "deadSymbolFlare";
    public static DEAD_COLLECT_UPDATE: string = "deadSymbolMultipler";
    public static DEAD_DISTRIBUTE: string = "deadSymbolFlareReturn";
    public static DEAD_DISTRIBUTE_UPDATE: string = "deadSymbolMultiplerLand";

    // win cap
    public static WIN_CAP: string = "winCap";

    // free spin locked FF
    public static CHAINS: string[] = ["chains01", "chains02", "chains03"];

    // +1 text
    public static PLUS_ONE: string = "plusOne";

    // anticipations
    public static ANTICIPATION_DEFAULT: string = "anticipationDefault";
    public static ANTICIPATION_DEFAULT_END: string = "anticipationDefaultEnd";
    public static ANTICIPATION_ELECTRIC: string = "anticipationElectric";
    public static ANTICIPATION_ELECTRIC_END: string = "anticipationElectricEnd";

    // scatter landing
    public static SCATTER_SCORPION: string[] = ["scatterScorpion1", "scatterScorpion2", "scatterScorpion3"];
    public static SCATTER_SPIDER: string[] = ["scatterSpider1", "scatterSpider2"];

    // special multipliers
    public static MULT_DEAD: string = "multDead";
    public static MULT_LAND: string = "multLand";
    static AS_WIN:string ="asWin";
    static AS_WIN_BIG:string = "asWinBig";
}